<template>
  <div>
    <div class="officers-details mb-4" v-if="officerDetails.length">
      <table style="width:100%">
        <tbody>
          <tr class="sticky-item">
            <td class="officer-header">Details of Officers</td>
            <td class="sub-header">Crew Name</td>
            <td class="sub-header">Nationality</td>
            <td class="sub-header">Certificate of Competency</td>
            <td class="sub-header">Issuing Country</td>
            <td class="sub-header">Administration Acceptance</td>
            <td class="sub-header">Experience in this type of Vessel</td>
            <td class="sub-header">Over all Experience</td>
            <td class="sub-header">English Knowledge</td>
            <td class="sub-header">Year in rank</td>
            <td class="sub-header">Tanker Cert</td>
            <td class="sub-header">Years with Operator</td>
            <td class="sub-header">STCW V para</td>
          </tr>
          <tr class="details-row" v-for="(tr,trindex) in officerDetails" :key="trindex">
            <td
              class="officer-header"
            >{{tr.qualification_role.name ? tr.qualification_role.name : '-'}}</td>
            <td class="sub-header">{{tr.crew_name ? tr.crew_name : '-'}}</td>
            <td class="sub-header">{{tr.nationality ? tr.nationality : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.certificate_of_competency ? tr.certificate_of_competency : '-'}}</td>
            <td class="sub-header">{{tr.issuing_country ? tr.issuing_country : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.administration_acceptance ? tr.administration_acceptance : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.experience_of_this_vessel ? tr.experience_of_this_vessel : '-'}}</td>
            <td class="sub-header">{{tr.overall_experience ? tr.overall_experience : '-'}}</td>
            <td class="sub-header">{{tr.english_knowledge ? tr.english_knowledge : '-'}}</td>
            <td class="sub-header">{{tr.years_in_rank ? tr.years_in_rank : '-'}}</td>
            <td class="sub-header">{{tr.tanker_certificate ? tr.tanker_certificate : '-'}}</td>
            <td class="sub-header">{{tr.years_with_operator ? tr.years_with_operator : '-'}}</td>
            <td class="sub-header">{{tr.stcw_level ? tr.stcw_level : '-'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="officers-details mb-4" v-if="engineerDetails.length">
      <table style="width:100%">
        <tbody>
          <tr class="sticky-item">
            <td class="officer-header">Details of Engineers</td>
            <td class="sub-header">Crew Name</td>
            <td class="sub-header">Nationality</td>
            <td class="sub-header">Certificate of Competency</td>
            <td class="sub-header">Issuing Country</td>
            <td class="sub-header">Administration Acceptance</td>
            <td class="sub-header">Experience in this type of Vessel</td>
            <td class="sub-header">Over all Experience</td>
            <td class="sub-header">English Knowledge</td>
            <td class="sub-header">Year in rank</td>
            <td class="sub-header">Tanker Cert</td>
            <td class="sub-header">Years with Operator</td>
            <td class="sub-header">STCW V para</td>
          </tr>
          <tr class="details-row" v-for="(tr,trindex) in engineerDetails" :key="trindex">
            <td
              class="officer-header"
            >{{tr.qualification_role.name ? tr.qualification_role.name : '-'}}</td>
            <td class="sub-header">{{tr.crew_name ? tr.crew_name : '-'}}</td>
            <td class="sub-header">{{tr.nationality ? tr.nationality : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.certificate_of_competency ? tr.certificate_of_competency : '-'}}</td>
            <td class="sub-header">{{tr.issuing_country ? tr.issuing_country : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.administration_acceptance ? tr.administration_acceptance : '-'}}</td>
            <td
              class="sub-header"
            >{{tr.experience_of_this_vessel ? tr.experience_of_this_vessel : '-'}}</td>
            <td class="sub-header">{{tr.overall_experience ? tr.overall_experience : '-'}}</td>
            <td class="sub-header">{{tr.english_knowledge ? tr.english_knowledge : '-'}}</td>
            <td class="sub-header">{{tr.years_in_rank ? tr.years_in_rank : '-'}}</td>
            <td class="sub-header">{{tr.tanker_certificate ? tr.tanker_certificate : '-'}}</td>
            <td class="sub-header">{{tr.years_with_operator ? tr.years_with_operator : '-'}}</td>
            <td class="sub-header">{{tr.stcw_level ? tr.stcw_level : '-'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  components: {},
  data() {
    return {
      officerDetails: [],
      engineerDetails: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      service: 0,
      services_drop: []
    };
  },
  props: ["consultantId", "serviceId"],
  computed: {},
  mounted() {
    this.getOfficersData();
  },
  methods: {
    async getOfficersData() {
      let input = {
        consultant_id: this.consultantId,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "qualification-details/list/" + this.$route.params.id,
        input
      );
      if (response) {
        let data = response.data;
        let officers = data.qualification_officer;
        let engineers = data.qualification_engineer;
        this.engineerDetails = engineers;
        this.officerDetails = officers;
      }
    }
  }
};
</script>
<style scoped>
table {
  display: table;
  border: none !important;
  border-collapse: collapse;
}
table tr {
  display: table-cell;
  border: none !important;
}
table tr td {
  padding: 15px 15px !important;
  border-bottom: 2px solid #f6f6f6;
  border-right: 2px solid #f6f6f6;
  display: block;
}
.officer-header {
  background: rgba(var(--vs-dark), 1) !important;
  color: #fff;
  font-weight: 600;
  border: none !important;
}
.details-row,
.details-row td {
  width: 300px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.sticky-item td {
  border-left: 2px solid #f6f6f6;
  width: 330px;
}
td {
  height: 52px;
  max-height: 52px;
}
.sub-header {
  background: #ffffff;
}
</style>
